import {pushDataLayer} from '@global/js/Mixins/helpers';
import {getOrCreateGoogleAnalyticsSessionId} from '@timon/js/Mixins/helpers';

export default function install(app) {
  app.config.globalProperties.$inertia.on('navigate', () => {
    pushDataLayer(function () {
      this.set('time', new Date());
    });
    pushDataLayer({
      event: 'session_id_ready',
      session_id: getOrCreateGoogleAnalyticsSessionId(),
    });
    pushDataLayer({
      event: 'custom_page_view',
      pagePath: window.location.pathname,
      pageTitle: window.document.title,
    });
  });
}
